import React, { useState, useEffect } from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';
import useStyles from './styles';

const Loading = ({ openLoading, dismiss }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(openLoading);

  useEffect(() => {
    setOpen(openLoading);
  }, [openLoading]);

  const handleCloseLoading = () => {
    if (dismiss) setOpen(false);
  };

  return (
    <Backdrop
      className={classes.backdrop}
      open={open}
      onClick={handleCloseLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

Loading.defaultProps = {
  dismiss: true,
};

export default Loading;
